export const dataVidaPiloto = [
  {
    id: 1,
    username: "Fabiola Morales",
    user: "fmoralec",
    channel: "vidapiloto",
    idClient: "fabiola.morales@rimac.com.pe",
    first: "Fabiola Morales",
  },
  {
    id: 2,
    username: "Ruth Bernaola",
    user: "RBERN",
    channel: "vidapiloto",
    idClient: "ruth.bernaola@rimac.com.pe",
    first: "Ruth Bernaola",
  },
  {
    id: 3,
    username: "Tania Calmet",
    user: "TanCalet",
    channel: "vidapiloto",
    idClient: "tania.calmet@rimac.com.pe",
    first: "Tania Calmet",
  },
  {
    id: 4,
    username: "Ingrid Galvez",
    user: "IngGalez",
    channel: "vidapiloto",
    idClient: "igalvezl@rimac.com.pe",
    first: "Ingrid Galvez",
  },
  {
    id: 5,
    username: "Claudia Puente Arnao",
    user: "ClaPuete",
    channel: "vidapiloto",
    idClient: "claudia.puentearnao@rimac.com.pe",
    first: "Puente Arnao",
  },
  {
    id: 6,
    username: "Sheila Salazar",
    user: "SheSalar",
    channel: "vidapiloto",
    idClient: "sheila.salazar@rimac.com.pe",
    first: "Sheila Salazar",
  },
  {
    id: 7,
    username: "Esmeralda Casamayor",
    user: "EsmCasor",
    channel: "vidapiloto",
    idClient: "esmeralda.casamayor@rimac.com.pe",
    first: "Esmeralda Casamayor",
  },
  {
    id: 8,
    username: "Lizet Sifuentes",
    user: "LizSifes",
    channel: "vidapiloto",
    idClient: "lizet.sifuentes@rimac.com.pe",
    first: "Lizet Sifuentes",
  },
  {
    id: 9,
    username: "Jovhanna de la Calle",
    user: "JDE L",
    channel: "vidapiloto",
    idClient: "jhovanna.delacalle@rimac.com.pe",
  },
  {
    id: 10,
    username: "Yremar Rondon",
    user: "yrondonc",
    channel: "vidapiloto",
    idClient: "yremar.rondon@rimac.com.pe",
    first: "Yremar Rondon",
  },
  {
    id: 11,
    username: "Carolina Rodriguez",
    user: "CarRodez",
    channel: "vidapiloto",
    idClient: "carolina.rodriguezo@rimac.com.pe",
    first: "Carolina Rodriguez",
  },
  {
    id: 12,
    username: "Jimmy Antonio",
    user: "jantonia",
    channel: "vidapiloto",
    idClient: "jimmy.antonio@rimac.com.pe",
    first: "Jimmy Antonio",
  },
  {
    id: 13,
    username: "Angie Llontop",
    user: "allontom",
    channel: "vidapiloto",
    idClient: "angie.llontop@rimac.com.pe",
    first: "Angie Llontop",
  },
  {
    id: 14,
    username: "Paul Rondón ",
    user: "prondond",
    channel: "vidapiloto",
    idClient: "paul.rondon@rimac.com.pe",
    first: "Paul Rondón ",
  },
  {
    id: 15,
    username: "Cinthya Zuñiga",
    user: "czunigab",
    channel: "vidapiloto",
    idClient: "cinthya.zuniga@rimac.com.pe",
    first: "Cinthya Zuñiga",
  },
  {
    id: 15,
    username: "Kenyi Lopez Hitotsuishi",
    user: "Klopezh",
    channel: "vidapiloto",
    idClient: "kenyi.lopez@rimac.com.pe",
    first: "Lopez Hitotsuishi",
  },
  {
    id: 16,
    username: "Paula Meiggs",
    user: "PauMeigs",
    channel: "vidapiloto",
    idClient: "paula.meiggs@rimac.com.pe",
    first: "Paula Meiggs",
  },
  {
    id: 17,
    username: "Fabiola Enriquez",
    user: "FabEnrez",
    channel: "vidapiloto",
    idClient: "fabiola.enriquez@rimac.com.pe",
    first: "Fabiola Enriquez",
  },
  {
    id: 18,
    username: "Isabel Piccone",
    user: "ipiccons",
    channel: "vidapiloto",
    idClient: "isabel.piccone@rimac.com.pe",
    first: "Isabel Piccone",
  },
  {
    id: 19,
    username: "Wendy Ramos",
    user: "wramosn",
    channel: "vidapiloto",
    idClient: "wendy.ramos@rimac.com.pe",
    first: "Wendy Ramos",
  },
  {
    id: 20,
    username: "Giancarlo Matias",
    user: "GMATI",
    channel: "vidapiloto",
    idClient: "giancarlo.matias@rimac.com.pe",
    first: "Giancarlo Matias",
  },
  {
    id: 21,
    username: "Sandra Galindo",
    user: "SanGaldo",
    channel: "vidapiloto",
    idClient: "sandra.galindo@rimac.com.pe",
    first: "Sandra Galindo",
  },
  {
    id: 22,
    username: "Yescoli Garcia",
    user: "ygarciaa",
    channel: "vidapiloto",
    idClient: "yescoli.garcia@rimac.com.pe",
    first: "Yescoli Garcia",
  },
  {
    id: 23,
    username: "Gabriela Contreras",
    user: "GabConas",
    channel: "vidapiloto",
    idClient: "gabriela.contreras@rimac.com.pe",
    first: "Gabriela Contreras",
  },
  {
    id: 24,
    username: "Betsy Acosta",
    user: "bacostad",
    channel: "vidapiloto",
    idClient: "betsy.acosta@rimac.com.pe",
    first: "Betsy Acosta",
  },
  {
    id: 25,
    username: "Stefanie Portillo",
    user: "cportilv",
    channel: "vidapiloto",
    idClient: "carmen.portillo@rimac.com.pe",
    first: "Stefanie Portillo",
  },
  {
    id: 26,
    username: "Manuel Cerra",
    user: "mcerral",
    channel: "vidapiloto",
    idClient: "manuel.cerra@rimac.com.pe",
    first: "Manuel Cerra",
  },
  {
    id: 27,
    username: "Cladey Huacac",
    user: "chuacach",
    channel: "vidapiloto",
    idClient: "cladey.huacac@rimac.com.pe",
    first: "Cladey Huacac",
  },
  {
    id: 28,
    username: "Felix Hernandez",
    user: "fhernace",
    channel: "vidapiloto",
    idClient: "felix.hernandezc@rimac.com.pe",
    first: "Felix Hernandez",
  },
  {
    id: 29,
    username: "Vanessa Guerrero",
    user: "vguerreu",
    channel: "vidapiloto",
    idClient: "vanessa.guerrero@rimac.com.pe",
    first: "Vanessa Guerrero",
  },
  {
    id: 30,
    username: "Lucy Enriquez",
    user: "lenriqui",
    channel: "vidapiloto",
    idClient: "lucy.enriquez@rimac.com.pe",
    first: "Lucy Enriquez",
  },
  {
    id: 32,
    username: "David Hugo Maiz Anamaco",
    user: "dahugo",
    channel: "vidapiloto",
    idClient: "xt8569@rimac.com.pe",
    first: "David Hugo Maiz Anamaco",
  },
  {
    id: 33,
    username: "Javier Eduardo Celis Antinori",
    user: "habibi",
    channel: "vidapiloto",
    idClient: "javier.celis@rimac.com.pe",
    first: "Javier Eduardo Celis Antinori",
  },
  {
    id: 34,
    username: "Elvis Jacobo Zamora",
    user: "elvisjacobo",
    channel: "vidapiloto",
    idClient: "elvisjacobo.zamora@rimac.com.pe",
    first: "Elvis Jacobo Zamora",
  }
];
